module.exports = __webpack_public_path__ + "img/add_to_apple_wallet_pt.6ef6708e.png";